import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  OtherExpensesCreateInput,
  OtherExpensesModel,
  OtherExpensesUpdateInput,
  OtherExpensesVoidInput,
} from './model';

export function useCreateOtherExpense(
  options?: UseMutationOptions<
    ApiResult<OtherExpensesModel>,
    ApiError,
    OtherExpensesCreateInput
  >,
): UseMutationResult<
  ApiResult<OtherExpensesModel>,
  ApiError,
  OtherExpensesCreateInput
> {
  return useMutation<
    ApiResult<OtherExpensesModel>,
    ApiError,
    OtherExpensesCreateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'other-expenses',
      method: 'POST',
      classType: OtherExpensesModel,
      body,
    });
  }, options);
}

export function useUpdateOtherExpense(
  options?: UseMutationOptions<
    ApiResult<OtherExpensesModel>,
    ApiError,
    OtherExpensesUpdateInput
  >,
): UseMutationResult<
  ApiResult<OtherExpensesModel>,
  ApiError,
  OtherExpensesUpdateInput
> {
  return useMutation<
    ApiResult<OtherExpensesModel>,
    ApiError,
    OtherExpensesUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `other-expenses/${body.otherExpenseRefId}`,
      method: 'PUT',
      classType: OtherExpensesModel,
      body: body.body,
    });
  }, options);
}

export function useVoidOtherExpense(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    OtherExpensesVoidInput
  >,
): UseMutationResult<{ message: string }, ApiError, OtherExpensesVoidInput> {
  return useMutation<{ message: string }, ApiError, OtherExpensesVoidInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `other-expenses/${body.otherExpenseRefId}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}
